import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import OutterLeftPanel from "../../../components/OutterLeftPanel";
import { isLoggedIn } from "../../../common/helpers";
import { resetUserPassword } from "./http/resetPasswordApi";
import abgLogo from "../../../assets/imgs/blue-logo.svg";
import AuthInput, { LockNoKeyholeIcon } from "../../../components/authentication-input/AuthInput";

export function ResetPassword() {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [newPasswordTouched, setNewPasswordTouched] = useState(false);
  const [confirmPasswordTouched, setConfirmPasswordTouched] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn()) {
      navigate("/");
    }
  });

  const newPasswordValue = newPassword.trim();
  const confirmPasswordValue = confirmPassword.trim();

  const isNewPasswordValid = newPasswordValue.length > 0;
  const isConfirmPasswordValid = confirmPasswordValue.length > 0;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await resetUserPassword({
        newPassword,
        confirmPassword,
        resetPasswordKey: token || "",
        oldPassword: null,
      });

      navigate("/login");
    } catch (err: any) {
      setError(err.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <div className="min-h-[100svh] bg-[#ECEEF3] p-5">
      <div className="mx-auto flex h-[calc(100svh-40px)] min-h-[720px] max-w-[1500px] gap-8 rounded-[24px]">
        <div className="flex w-1/2 items-center justify-center">
          <div className="w-full max-w-[440px] rounded-[7px] bg-white px-7 py-7">
            <div className="relative mb-8 flex w-full items-center">
              <img
                src={abgLogo}
                alt="ABG | accord business group"
                className="h-6 w-auto object-contain"
              />
              <span className="absolute left-1/2 -translate-x-1/2 text-[20px] font-bold text-[#6F7F96]">
                Mynd
              </span>
            </div>

            <h2 className="mb-7 text-[20px] font-bold text-[#6F7F96]">
              Reset Password
            </h2>

            <form onSubmit={handleSubmit}>
              <AuthInput
                label="New Password"
                type="password"
                value={newPassword}
                onChange={setNewPassword}
                leftIcon={<LockNoKeyholeIcon className="block" />}
                isValid={isNewPasswordValid}
                touched={newPasswordTouched}
                setTouched={setNewPasswordTouched}
                inputTextColorClassName="text-[#32445A]"
                required
              />

              <AuthInput
                label="Confirm Password"
                type="password"
                value={confirmPassword}
                onChange={setConfirmPassword}
                leftIcon={<LockNoKeyholeIcon className="block" />}
                isValid={isConfirmPasswordValid}
                touched={confirmPasswordTouched}
                setTouched={setConfirmPasswordTouched}
                inputTextColorClassName="text-[#32445A]"
                required
              />

              {error && <p className="mb-4 text-sm text-red-500">{error}</p>}

              <button
                type="submit"
                className="mt-4 h-[40.7px] w-full rounded-[8px] bg-[#3538FF] text-[16px] font-semibold text-white transition hover:bg-[#2D2EFF]"
              >
                Reset Password
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link
                to="/login"
                className="text-sm text-[#2D2EFF] hover:text-[#2424CC]"
              >
                Back to Login
              </Link>
            </div>
          </div>
        </div>

        <OutterLeftPanel />
      </div>
    </div>
  );
}